import {AfterViewInit, Component, EventEmitter, Input, Output} from "@angular/core";
import {SignupService} from "../signup.service";
import {SignupModel, SignupPages} from "../signup.model";
import {FUISpinnersService} from "@fedelta-pos/ui";

@Component({
    selector: "fhm-signup-page-content-content",
    styleUrls: ["./signup-page-content.component.scss"],
    templateUrl: "./signup-page-content.component.html",
    providers: [SignupService, SignupModel],
    standalone: false
})
export class SignupPageContentComponent implements AfterViewInit {

    SignupPages = SignupPages;

    @Input() url: string;

    @Input() showClose: boolean;

    @Output() closed: EventEmitter<any> = new EventEmitter();

    constructor(public model: SignupModel,
                private spinnersService: FUISpinnersService) {
    }

    ngAfterViewInit(): void {
        this.init(this.url ? this.url : window.location.hash);
    }

    async init(url: string): Promise<void> {
        const token: string = url.substr(url.indexOf("?d=") + 3);
        this.spinnersService.open();
        try {
            await this.model.load(token);
        } finally {
            this.spinnersService.close();
        }
    }

    async confirmBilling(): Promise<void> {
        this.spinnersService.open();
        try {
            await this.model.confirmBilling();
        } finally {
            this.spinnersService.close();
        }
    }
}
